/**
 * The line of each section's heading and of each of its properties, filed under what the section builds, so a
 * diagnostic lands on its line.
 */
export function sectionLines() {
    const lines = new Map();
    // A fresh map per heading, since the finished one is kept.
    let propertyLines = new Map();
    return {
        lines,
        start() {
            propertyLines = new Map();
        },
        record(key, line) {
            propertyLines.set(key, line);
        },
        built(section, headingLine) {
            lines.set(section, { heading: headingLine, properties: propertyLines });
        },
    };
}
//# sourceMappingURL=sectionLines.js.map